import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";

const handleError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001" || body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.ok === false && body.msg) {
    Swal.fire(t("titles.error"), body.msg, "error");
  }
};

export const startLoadingFlowAssignmentPolicies = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_ASSIGNMENT_POLICY_SET_LOADING, payload: true });
    try {
      const query = new URLSearchParams(
        Object.entries(filters).filter(([, value]) => value !== "" && value !== null && value !== undefined)
      ).toString();
      const suffix = query ? `get?${query}` : "get";
      const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_ASSIGNMENT_POLICY, suffix);
      const body = await resp.json();
      if (body.ok) {
        dispatch({ type: types.FLOW_ASSIGNMENT_POLICY_SET_LIST, payload: body.flowAssignmentPolicies || [] });
      } else {
        handleError(body, dispatch);
      }
    } finally {
      dispatch({ type: types.FLOW_ASSIGNMENT_POLICY_SET_LOADING, payload: false });
    }
  };
};

export const startUpdateFlowAssignmentPolicyRule = (id, data) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      const_routes.SCHEMA,
      const_routes.VERSIONV1,
      const_routes.ROUTE_FLOW_ASSIGNMENT_POLICY,
      `rule/${id}`,
      data,
      "PUT"
    );
    const body = await resp.json();
    if (body.ok) {
      return body.flowAssignmentPolicyRule;
    }
    handleError(body, dispatch);
    return null;
  };
};

export const startReorderFlowAssignmentPolicyRules = (policyId, orderedIds) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      const_routes.SCHEMA,
      const_routes.VERSIONV1,
      const_routes.ROUTE_FLOW_ASSIGNMENT_POLICY,
      `reorder/${policyId}`,
      { ordered_ids: orderedIds },
      "PUT"
    );
    const body = await resp.json();
    if (body.ok) {
      return true;
    }
    handleError(body, dispatch);
    return false;
  };
};
